// This sample uses the Places Autocomplete widget to:
// 1. Help the user select a place
// 2. Retrieve the address components associated with that place
// 3. Populate the form fields with those address components.
// This sample requires the Places library, Maps JavaScript API.
// Include the libraries=places parameter when you first load the API.
// For example: <script
// src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">

let autocomplete;
let address1Field;
let address2Field;
let fNameField;
let postalField;

function initAutocomplete() {
  fNameField = document.querySelector("#first-name");
  address1Field = document.querySelector("#address1");
  address2Field = document.querySelector("#address2");
  postalField = document.querySelector("#zip");

  if (!address1Field) return;

  window.loadGoogle.then(() => {
    // Create the autocomplete object, restricting the search predictions to
    // addresses in the US and Canada.
    autocomplete = new google.maps.places.Autocomplete(address1Field, {
      componentRestrictions: { country: ["us"] },
      fields: ["address_components", "geometry"],
      types: ["address"],
    });
    fNameField.focus();
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    autocomplete.addListener("place_changed", fillInAddress);
  });
}

function fillInAddress() {
  // Get the place details from the autocomplete object.
  const place = autocomplete.getPlace();
  let address1 = "";
  let postcode = "";
  let city = "";
  let state = "";

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // place.address_components are google.maps.GeocoderAddressComponent objects
  // which are documented at http://goo.gle/3l5i5Mr
  for (const component of place.address_components) {
    // @ts-ignore remove once typings fixed
    const componentType = component.types[0];
    switch (componentType) {
      case "street_number": {
        address1 = `${component.long_name} ${address1}`;
        break;
      }

      case "route": {
        address1 += component.short_name;
        break;
      }

      case "postal_code": {
        postcode = `${component.long_name}${postcode}`;
        break;
      }

      case "postal_code_suffix": {
        postcode = `${postcode}`;
        break;
      }
      case "locality":
        document.querySelector("#city").value = component.long_name;
        city = component.long_name;
        break;
      case "administrative_area_level_1": {
        document.querySelector("#state").value = component.long_name;
        state = component.long_name;
        break;
      }
      // case "country":
      //   document.querySelector("#country").value = component.long_name;
      //   break;
    }
  }

  address1Field.value = address1;
  postalField.value = postcode;
  const addressUpdated = new CustomEvent("addressUpdate", {
    detail: {
      add1: address1,
      city: city,
      state: state,
      zip: postcode,
    },
  });
  document.dispatchEvent(addressUpdated);
  // After filling the form with address components from the Autocomplete
  // prediction, set cursor focus on the second address line to encourage
  // entry of subpremise information such as apartment, unit, or floor number.
  fNameField.focus();
}

function getLatLong(address, callback) {
  const query = `https://api.opencagedata.com/geocode/v1/json?key=36e78b5c69ff449eb5c208ddb01c2464&q=${encodeURIComponent(
    address
  )}&pretty=1`;
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  fetch(query, requestOptions)
    .then((response) => response.json())
    .then((result) => callback(result))
    .catch((error) => console.log("error", error));
}

function runLocation() {
  let located = window.localStorage.getItem("country");

  const redirect = () => {
    document.location.href = "https://goveer.de/";
  };

  // If de market, redirect immediately
  if (document.location.href.indexOf("en-de") > -1) {
    window.localStorage.setItem("country", true);
    redirect();
    return;
  }

  if (located) return;

  fetch("/browsing_context_suggestions.json")
    .then((res) => res.json())
    .then((result) => {
      // Also redirect if ip is geolocated within the following countries
      const countriesToRedirect = ["DE", "AT", "NL", "BE", "LU", "FR"];

      window.localStorage.setItem("country", true);
      if (countriesToRedirect.includes(result.detected_values.country.handle)) {
        redirect();
      }
    })
    .catch((error) => console.log("error", error));
}
runLocation();

window.loadGoogle = new Promise((resolve) => {
  window.onGoogleLoad = () => {
    resolve();
  };
});

window.getLatLong = getLatLong;
window.initAutocomplete = initAutocomplete;
